/**
 * Traduce el código de estatus del documento de compra de SAP (nodo
 * `OrdenCompra/estatus` de la OC/CA) a un texto legible para el usuario.
 *
 * Semántica (ver regla de ingesta en ComprasSAP):
 *   0 = CREACIÓN               · solo alta; si ya existe una versión activa es error.
 *   1 = CREACIÓN/ACTUALIZACIÓN  · alta si no existe, o nueva versión si ya existe.
 */
export function etiquetaEstatusCompra(estatus: string | null | undefined): string {
  const code = (estatus ?? "").trim();
  switch (code) {
    case "0":
      return "Creación";
    case "1":
      return "Creación / Actualización";
    case "":
      return "—";
    default:
      return code;
  }
}
